import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

// `Calendly` is a Sprockets-era global: the view loads assets.calendly.com/widget.js inline, which
// has evaluated by the time connect() runs.
export default class extends Controller {
  static get targets() { return ["calendar", "next"]; }

  static get values() {
    return { calendarUrl: String, name: String, email: String, submitUrl: String };
  }

  connect() {
    Calendly.initInlineWidget({
      url: this.calendarUrlValue,
      parentElement: this.calendarTarget,
      prefill: this.prefill(),
      utm: {}
    });
  }

  scheduled(event) {
    if (event.data.event !== "calendly.event_scheduled") { return; }
    if (this.submitUrlValue === "#") { return; }

    const options = RequestHelper.defaultPostOptions();
    options.headers = Object.assign({}, options.headers, { "Content-Type": "application/json" });
    options.body = JSON.stringify({ uri: event.data.payload.invitee.uri });

    fetch(this.submitUrlValue, options).
      then(response => {
        if (!response.ok) { throw new Error(`Booking the meeting failed (${response.status})`); }
        this.nextTarget.removeAttribute("disabled");
      }).
      catch(this.logFailedCall);
  }

  // The preview renders neither name nor email, and an absent key is not an empty one to Calendly.
  prefill() {
    const prefill = {};
    if (this.hasNameValue) { prefill.name = this.nameValue; }
    if (this.hasEmailValue) { prefill.email = this.emailValue; }
    return prefill;
  }

  logFailedCall(response) { console.warn(response); }
}
